import { render, staticRenderFns } from "./searchgraduate.vue?vue&type=template&id=244d6968&scoped=true"
import script from "./searchgraduate.vue?vue&type=script&lang=js"
export * from "./searchgraduate.vue?vue&type=script&lang=js"
import style0 from "./searchgraduate.vue?vue&type=style&index=0&id=244d6968&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244d6968",
  null
  
)

export default component.exports